module.exports = __webpack_public_path__ + "/b68abc4a5ee2729fab9e6b8ef2c92fd9.png";